import AppConstants from '../config/app.constants';

let CountVariancesService = function ($http, $q) {

    let countVariances = (searchText, branchId, startDate, endDate, offset, limit, sortASC, sortColumn, timezone) => {
        return $http
            .get(AppConstants.api + `/count-variances/get-count-variances`, {
                params: {
                    searchText,
                    branchId,
                    startDate,
                    endDate,
                    offset,
                    limit,
                    sortASC,
                    sortColumn,
                    timezone
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let exportCountVariances = (searchText, branchId, startDate, endDate, sortASC, sortColumn, timezone) => {
        return $http
            .post(AppConstants.api + `/count-variances/export-count-variances`, {
                searchText,
                branchId,
                startDate,
                endDate,
                sortASC,
                sortColumn,
                timezone
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        countVariances,
        exportCountVariances,
    };
};

CountVariancesService.$inject = ['$http', '$q'];

export default CountVariancesService;


// WEBPACK FOOTER //
// ./client/app/services/count-variances.service.js